import React, { useState, useEffect } from "react";
import "./EmployerCard.css";
import { Modal,Button, Row, Drawer } from "antd";
import Activate from "./Activate";
import history from "../../../routes/history";

import { useSelector, useDispatch } from "react-redux";
import { getPendingTeamMembers, getActiveTeamMembers, getInActiveTeamMembers, reactivateTeamMember } from "../../../redux/actions";
import { CloseOutlined } from "@ant-design/icons";

function EmployerCard({ items, Status }) {
  const success = useSelector(
    (state) => state.reactivateTeamMembersReducer.response
  );

  const dispatch = useDispatch();

  const [showModal, setShowModal] = useState(false);
  const [Dimensions, setDimensions] = useState(getWindowDimensions());
  const [isReactivateModalVisible, setIsReactivateModalVisible] =
    useState(false);
    const userProfile = JSON.parse(localStorage.getItem("userProfile"));
    function getWindowDimensions() {
    const { innerWidth: width, innerHeight: height } = window;
    return {
      width,
      height,
    };
  }
  

  const handleReactivateOk = () => {
    dispatch(reactivateTeamMember(items._id));

    setIsReactivateModalVisible(false);
  };

  const handleReactivateCancel = () => {
    setIsReactivateModalVisible(false);
  };

  useEffect(() => {
    function handleResize() {
      setDimensions(getWindowDimensions());
    }

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const customCloseIcon = (
    <div style={{ position: 'absolute', top: "20px", right: "20px" }}>
      <CloseOutlined />
    </div>
  );

  return (
    <div className="Myteam-tabContainer Container">
      <Drawer
        title={<div className="activate-team">Activate</div>}
        // visible={showModal}
        open={showModal}
        // destroyOnClose={true}
        onCancel={() => setShowModal(false)}
        className="add-Team-Member"
        footer={null}
        width={600}
        height={"85vh"}
        placement="top"
        closeIcon={customCloseIcon}
        // afterClose={() => {
        //   dispatch(getPendingTeamMembers());
        //   dispatch(getActiveTeamMembers());
        //   dispatch(getInActiveTeamMembers());
        // }}
        onClose={() => {
          dispatch(getPendingTeamMembers());
          dispatch(getActiveTeamMembers());
          dispatch(getInActiveTeamMembers());
        }}
       
      >
        <Activate
          invitationId={items._id}
          Full_Name={items.FullName ? items.FullName : items.UserName}
          Email={items.EmailAddress}
          Job_Title={items.JobTitle}
          CompanyName={userProfile?.Profiles?.CompanyName}
          setShowModal={setShowModal}
        />
      </Drawer>



      <Modal  
     width={'340px'}
     bodyStyle={{ paddingLeft:'1rem'}}
     confirmLoading={true}
       title= {<div 
         style={{
           paddingLeft:'-8px',
           // position: 'absolute',
           // width: '129px',
           // height: '30px',
           // left: '15px',
           // top: '16px', 
           // bottom: '10px',
           fontStyle: 'normal',
           fontWeight: '500',
           fontSize: '16px',
           lineHeight: '19px', 
           color: '#3E3E3E'
         }}>
           Reactivate user?</div>}
        visible={isReactivateModalVisible} 
        closable={false}
        onOk={handleReactivateOk}
        onCancel={handleReactivateCancel}
        centered={true}
        afterClose={() => {
          success && dispatch(getPendingTeamMembers());
          dispatch(getActiveTeamMembers());
          dispatch(getInActiveTeamMembers());
        }}
        footer={null}
      >
         <p style={{marginTop:'-12px',marginBottom:'5px', fontSize:'16px',
         marginLeft:'1rem',
        color: '#3E3E3E',
  fontStretch: 'normal',
  fontStyle: 'normal',
  lineHeight: 'normal',
        }}>Do you want to reactivate employer name </p>
       
        <div style={{  
          marginLeft:'1rem',
          marginRight:'1rem',
          justifyContent: 'space-between',
          display : "flex",
        flexDirection:'row'}}>
         <Button
            // className="button-cancel"
            onClick={handleReactivateCancel}
            style={{ 
              padding: '12px 0px 12px 0px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              height:'40px',
              borderWidth:'0px', 
              backgroundColor: '#fff',
              color: 'rgb(181, 179, 179)',
              fontSize: '16px',
              fontWeight: '600',
              marginTop: 10,
              width: "47%",
              marginLeft: 0, 
            }}
          >
            No
          </Button>

          <Button
            // className="button-cancel"
            onClick={handleReactivateOk}
            style={{
              color:'#fff',
              padding: '12px 0px 12px 0px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              height:'40px',
              borderRadius: '4px',
              backgroundColor: '#118936', 
              fontSize: '16px',
              fontWeight: '600',
              marginTop: 10,
              width: "47%",
              marginLeft: 0, 
            }}
          >
            Yes
          </Button>
          </div>
      </Modal>
      <div className="CardContainer">
        <div className="CardContent">
          <div className="EmployerName">{items?.Profiles?.FirstName ? items?.Profiles?.FirstName+" "+items?.Profiles?.LastName : items?.FullName ? items?.FullName : items?.UserName}</div>
          <div className="Mail">{items?.EmailAddress}</div>
          {Status === "Active" && <div className="Active">Active</div>}
          {Status === "Pending" && (
            <div style={{ display: "flex", justifyContent: "space-between" }}>
              <div className="Pending">Pending</div>

              <button
                className="Activate-button"
                onClick={
                  Dimensions.width < 769
                    ? () => setShowModal(true)
                    : () =>
                        history.push({
                          pathname: "/myteams/activate",
                          state: {
                            Id: items._id,
                            Name: items.FullName ? items.FullName : items.UserName,
                            Email: items.EmailAddress,
                            JobTitle: items.JobTitle,
                            CompanyName: userProfile?.Profiles?.CompanyName,
                          },
                        })
                }
              >
                Activate
              </button>
            </div>
          )}
          {Status === "Inactive" && (
            <Row style={{ width: "100%", justifyContent: "space-between" }}>
              <div className="Inactive">Inactive</div>
              <button
                className="Activate-button"
                onClick={() => setIsReactivateModalVisible(true)}
              >
                Reactivate
              </button>
            </Row>
          )}
        </div>
      </div>
    </div>
  );
}

export default EmployerCard;
